import { GenericObject } from "../types";
import isAbsolutePath from "./isAbsolutePath";
import styleToObj from "./styleToObj";

type transformOptions = {
    assetsPath?: string;
}
/**
 * 
 * @param styleStr 
 * @returns 
 */
export default function transformMVAttribs(attributes: GenericObject, options?: transformOptions): Object {
    let result: GenericObject = {};
    const regexIsFile = /\.([a-z0-9]+)(?:[\?#]|$)/i;

    //console.log({attributes, options});

    Object.keys(attributes).forEach((key) => {
        if (key === "style" && typeof attributes[key] === 'string') {
            result[key] = styleToObj(attributes[key]);
        } else if ((
            key === "skybox-image" 
            || key === "environment-image"
        ) && options?.assetsPath && attributes[key].match(regexIsFile) && !isAbsolutePath(attributes[key])) {
            result[key] = options.assetsPath + '/' + attributes[key];
        }
        else if (attributes[key] !== false) {
            result[key] = attributes[key];
        }
    });

    return result;
}
